import { Collection, Token } from './types';

export const fontSize = new Collection({
  xs: new Token('12px', 'font-size-xs'),
  sm: new Token('14px', 'font-size-sm'),
  md: new Token('16px', 'font-size-md'),
  lg: new Token('18px', 'font-size-lg'),
  xl: new Token('20px', 'font-size-xl'),
  '2xl': new Token('24px', 'font-size-2xl'),
  '3xl': new Token('30px', 'font-size-3xl'),
});

export const lineHeight = new Collection({
  xs: new Token('16px', 'line-height-xs'),
  sm: new Token('20px', 'line-height-sm'),
  md: new Token('24px', 'line-height-md'),
  lg: new Token('28px', 'line-height-lg'),
  xl: new Token('28px', 'line-height-xl'),
  '2xl': new Token('32px', 'line-height-2xl'),
  '3xl': new Token('36px', 'line-height-3xl'),
});

export const fontWeight = new Collection({
  regular: new Token('400', 'font-weight-regular'),
  medium: new Token('500', 'font-weight-medium'),
  semibold: new Token('600', 'font-weight-semibold'),
});

export const fontFamily = new Collection({
  sans: new Token(
    [
      'Averta',
      'ui-sans-serif',
      'system-ui',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      '"Noto Color Emoji"',
    ].join(','),
    'font-family-sans',
  ),
  mono: new Token(
    [
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      '"Liberation Mono"',
      '"Courier New"',
      'monospace',
    ].join(','),
    'font-family-mono',
  ),
});
